import type { ReactNode } from 'react';

interface AppShellProps {
  children: ReactNode;
  aiIdPrefix?: string;
}

export function AppShell({ children, aiIdPrefix = 'latinplace-app-shell' }: AppShellProps) {
  return (
    <main className="mx-auto min-h-screen w-full max-w-[640px] bg-white px-4 py-5 shadow-sm" data-ai-id={aiIdPrefix}>
      <div className="contents" data-ai-id={`${aiIdPrefix}-content`}>
        {children}
      </div>
    </main>
  );
}
